var React = require('react');

function HeartHollowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.62 18.71C11.28 18.83 10.72 18.83 10.38 18.71C7.48 17.72 1 13.59 1 6.59C1 3.5 3.49 1 6.56 1C8.38 1 9.99 1.88 11 3.24C12.01 1.88 13.63 1 15.44 1C18.51 1 21 3.5 21 6.59C21 13.59 14.52 17.72 11.62 18.71Z","stroke":"#021546","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

HeartHollowInline.defaultProps = {"width":"22","height":"20","viewBox":"0 0 22 20","fill":"none"};

module.exports = HeartHollowInline;

HeartHollowInline.default = HeartHollowInline;
